import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿Cual es la dosis que debo tomar?',
    answer: 'Se recomienda 4.1 gramos (1 scoop) al dia.'
  }, {
    question: '¿Cuánto tiempo debo tomarlo?',
    answer: 'Se recomienda un mínimo de 3 meses para permitir que el ciclo hormonal se complete tres veces bajo el efecto del inositol.'
  }, {
    question: '¿Puedo tomarlo con otros medicamentos?',
    answer: 'MyoChiro-Pro es un suplemento alimenticio, pero siempre recomendamos informar a tu médico tratante.'
  }, {
    question: '¿Qué lo hace diferente al inositol de farmacia?',
    answer: 'La mayoría son Myo-Inositol puro. Nosotros incluimos D-Chiro-Inositol en la proporción patenta 40:1, crucial para el SOP.'
  }, {
    question: '¿Envían a todo México?',
    answer: 'Sí, utilizamos paqueterías de alta confianza con seguimiento en tiempo real.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-20 md:py-32 bg-warm-gray text-dark" data-id="element-57">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-58">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-59">
          <h2 className="text-3xl md:text-4xl font-heading mb-6" data-id="element-60">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-61">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className={`bg-white rounded-2xl overflow-hidden border transition-colors duration-300 ${openIndex === index ? 'border-pink-brand shadow-md' : 'border-transparent shadow-sm'}`} data-id="element-62">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex justify-between items-center text-left focus:outline-none" data-id="element-63">
                <span className={`font-bold text-lg ${openIndex === index ? 'text-pink-brand' : 'text-dark'}`} data-id="element-64">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 transition-transform duration-300 ${openIndex === index ? 'rotate-180 text-pink-brand' : 'text-gray-400'}`} data-id="element-65" />
              </button>

              <AnimatePresence data-id="element-66">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-67">
                    <div className="px-6 pb-5 text-gray-600" data-id="element-68">{faq.answer}</div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}